import React, { Component, Fragment } from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import * as Scroll from "react-scroll";
import axios from "axios";
import * as qs from "query-string";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Img from "gatsby-image";
import goArrow from "../assets/icon-arrow-electric.svg";
import tick from "../assets/icon-complete.svg";
import * as styles from "./pageHeader.module.less";
import { ErrorDiv, StyledCheckbox } from "./newsletterStyles";
import DemoModal from "./MEL/demoModal";
import ConfirmationModal from "./MEL/confirmationModal";

const { scroller } = Scroll;

const WhatYouGetWrapper = styled.div`
  margin-top: 40px;
`;

const BlueText = styled.div`
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.02px;
  color: #03d4ff;
  margin-bottom: 20px;
`;

const TextRow = styled.div`
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
`;

const Tick = styled.img`
  margin-right: 10px;
`;

const StartTrailCard = styled.div`
  border-radius: 16px;
  box-shadow: 0 6px 20px 0 rgba(36, 45, 65, 0.1);
  background-color: #fff;
  width: 556px;
  height: 508px;
  padding: 48px;
  @media screen and (max-width: 451px) {
    width: auto;
    height: auto;
    padding: 20px;
  }
`;

const CardHeader = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  color: #242d41;
  margin-bottom: 40px;
`;

const EmailHeader = styled.div`
  font-weight: 600;
  line-height: 1.14;
  color: #242d41;
  margin-bottom: 8px;
`;

const StyledEmailInput = styled.input`
  width: 400px;
  height: 50px;
  padding-left: 10px;
  border-radius: 4px;
  border: solid 1px #126fd6;
  color: #242d41;
  background-color: #f6f8fb;
  margin-bottom: 20px;
  @media screen and (max-width: 451px) {
    width: 100%;
  }
`;

const NewsLetterWrapper = styled.div`
  display: flex;
  color: rgba(36, 45, 65, 0.9);
  font-size: 18px;
  line-height: 1.33;
`;

const CheckboxWrapper = styled.div`
  margin-top: 4px;
`;

const TermsWrapper = styled.div`
  color: rgba(36, 45, 65, 0.9);
  font-size: 18px;
  line-height: 1.33;
  margin-top: 28px;
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
`;

const TrialButton = styled.button`
  width: 203px;
  height: 46px;
  padding: 0 24px;
  border-radius: 23px;
  font-size: 16px;
  border: solid 2px #19c185;
  background-color: #19c185;
  margin-right: 10px;
  &:focus {
    outline: none;
  }
  @media screen and (max-width: 451px) {
    width: auto;
    padding: 0 8px;
  }
`;

const ScheduleDemoButton = styled.button`
  width: 180px;
  height: 46px;
  padding: 0;
  font-size: 16px;
  border-radius: 23px;
  font-weight: bold;
  color: #1e5bb5;
  background-color: #fff;
  border: solid 2px #1e5bb5;
  @media screen and (max-width: 451px) {
    width: auto;
    padding: 0 8px;
  }
`;

export default class pageHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      email: "",
      emailError: false,
      invalidEmail: false,
      newsletter: false,
      demoModalVisible: false,
      confirmationModalVisible: false,
    };
  }

  handleEmailAdd = (value) => {
    this.setState({ email: value, emailError: false, invalidEmail: false });
  };

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  handleSubmitTrial = async (event) => {
    const { email, newsletter } = this.state;
    event.preventDefault();

    if (!email) {
      if (!email) this.setState({ emailError: true });
      return;
    }
    if (!this.validateEmail(email)) {
      this.setState({ invalidEmail: true });
      return;
    }
    const formData = {
      email: email,
      newsletter: newsletter,
      identifier: "mel-manager-trial",
      "form-name": "mel-manager-trial",
    };
    const axiosOptions = {
      url: window.location.href,
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: qs.stringify(formData),
    };
    axios(axiosOptions)
      .then(() => {
        this.setState({
          email: "",
          newsletter: false,
          confirmationModalVisible: true,
        });
      })
      .catch((err) => {
        console.error("Submission failed");
      });
  };

  render() {
    const {
      link,
      linkText,
      bigHeader,
      bigImage,
      useBgImage,
      mediumHeader,
      bgImg,
      handleLinkScroll,
      imageWithShadow,
      longTag,
      svgImage,
      centrik,
      trial,
      customImageClass,
      imgWrapper: ImgWrapper,
    } = this.props;

    const {
      emailError,
      invalidEmail,
      newsletter,
      demoModalVisible,
      confirmationModalVisible,
    } = this.state;

    return (
      <div
        className={`${styles.pageHeader} ${bigHeader && styles.bigHeader} ${
          useBgImage && styles.pageHeaderBg
        } ${mediumHeader && styles.pageHeaderMedium} ${
          longTag && styles.longTag
        }
          ${centrik && styles.pageHeaderCentrik}`}
        style={
          bgImg && {
            backgroundImage: `url(${bgImg.childImageSharp.fluid.src})`,
          }
        }
      >
        <Container>
          <Row>
            {bigHeader ? (
              <Fragment>
                <Col md={trial ? 6 : 5} className={styles.headerTextCol}>
                  <AnimationOnScroll
                    animateOnce
                    animateIn="animate__fadeIn"
                    offset={0}
                  >
                    <div className={styles.flexParent}>
                      <div>
                        {this.props.tag && (
                          <div className={styles.headerTag}>
                            {this.props.tagStrong && (
                              <span className={styles.headerTagStrong}>
                                {this.props.tagStrong}
                              </span>
                            )}
                            <span className={styles.headerTagNormal}>
                              {this.props.tag}
                            </span>
                          </div>
                        )}
                        {this.props.logo && (
                          <img
                            src={this.props.logo}
                            alt="logo"
                            style={{ marginBottom: "20px" }}
                          />
                        )}
                      </div>
                      <div
                        className={`${styles.headerDiv} ${
                          centrik && styles.headerDivCentrik
                        }`}
                      >
                        <h1
                          className={trial ? styles.trialHeader : styles.header}
                          dangerouslySetInnerHTML={{
                            __html: this.props.header,
                          }}
                        />
                      </div>
                      <div>
                        <h2
                          className={styles.subHeader}
                          dangerouslySetInnerHTML={{
                            __html: this.props.subHeader,
                          }}
                        />
                      </div>
                      {trial && (
                        <WhatYouGetWrapper>
                          <BlueText>WHAT YOU GET ON THE FREE PLAN:</BlueText>
                          <TextRow>
                            <Tick src={tick} alt="tick" />
                            Full access to MEL Manager for 14 days
                          </TextRow>
                          <TextRow>
                            <Tick src={tick} alt="tick" />
                            Ability to create unlimited Aircrafts MELs and PDF
                            export
                          </TextRow>
                          <TextRow>
                            <Tick src={tick} alt="tick" />
                            Sample MEL templates
                          </TextRow>
                          <TextRow>
                            <Tick src={tick} alt="tick" />
                            Training and customer support
                          </TextRow>
                        </WhatYouGetWrapper>
                      )}
                      {link && linkText && (
                        <Row>
                          <Col className={styles.actionLinkHolder}>
                            <Link
                              to={link}
                              className={`${styles.actionLink} ${
                                this.props.whiteLink && styles.actionLinkWhite
                              }`}
                              onClick={(e) => {
                                if (handleLinkScroll) {
                                  handleLinkScroll(e);
                                }
                              }}
                            >
                              {linkText}
                              <span>
                                <img src={goArrow} alt="goArrow" />
                              </span>
                            </Link>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </AnimationOnScroll>
                </Col>
                <Col md={trial ? 6 : 7}>
                  <AnimationOnScroll
                    animateOnce
                    animateIn="animate__fadeIn"
                    offset={0}
                    style={{ height: "100%" }}
                  >
                    <div
                      className={`${styles.headerImage} ${
                        centrik && styles.headerImageCentrik
                      }`}
                    >
                      {svgImage ? (
                        trial ? (
                          <StartTrailCard>
                            <CardHeader>
                              Start your journey with MEL Manager trial account
                              - No credit card needed!
                            </CardHeader>
                            <form
                              name="mel-manager-trial"
                              method="post"
                              data-netlify="true"
                              data-netlify-honeypot="bot-field"
                              onSubmit={(event) =>
                                this.handleSubmitTrial(event)
                              }
                            >
                              <input type="hidden" name="email" />
                              <input type="hidden" name="identifier" />
                              <input
                                type="hidden"
                                name="form-name"
                                value="mel-manager-trial"
                              />
                              <EmailHeader>Work email</EmailHeader>
                              <StyledEmailInput
                                type="text"
                                onChange={(e) =>
                                  this.handleEmailAdd(e.target.value)
                                }
                              />
                              {emailError ? (
                                <ErrorDiv>This field is required.</ErrorDiv>
                              ) : null}
                              {invalidEmail ? (
                                <ErrorDiv>
                                  This must be a valid email address
                                </ErrorDiv>
                              ) : null}
                              <NewsLetterWrapper>
                                <CheckboxWrapper>
                                  <StyledCheckbox
                                    type="checkbox"
                                    onChange={() =>
                                      this.setState({ newsletter: !newsletter })
                                    }
                                    checked={newsletter}
                                  />
                                </CheckboxWrapper>
                                Yes, I would like to receive promotional emails,
                                including product news, events and more.
                              </NewsLetterWrapper>
                            </form>
                            <TermsWrapper>
                              By submitting this form, I agree to TrustFlight's{" "}
                              <Link to="/terms">Terms of Service</Link> and
                              acknowledge its{" "}
                              <Link to="/legal">Privacy Policy</Link>.
                            </TermsWrapper>
                            <ButtonWrapper>
                              <TrialButton
                                onClick={(e) => this.handleSubmitTrial(e)}
                              >
                                Start your free trial
                              </TrialButton>
                              <ScheduleDemoButton
                                onClick={(e) => this.handleSubmitTrial(e)}
                              >
                                Schedule a demo
                              </ScheduleDemoButton>
                            </ButtonWrapper>
                          </StartTrailCard>
                        ) : (
                          <img
                            src={bigImage}
                            alt="header"
                            className={`${
                              imageWithShadow && styles.imageWithShadow
                            } ${centrik && styles.centrikImage} ${
                              customImageClass || ""
                            }`}
                          />
                        )
                      ) : ImgWrapper ? (
                        <ImgWrapper>
                          <Img
                            fluid={bigImage}
                            className={
                              imageWithShadow && styles.imageWithShadow
                            }
                          />
                        </ImgWrapper>
                      ) : (
                        <Img
                          fluid={bigImage}
                          className={`${
                            imageWithShadow && styles.imageWithShadow
                          } ${customImageClass || ""}`}
                        />
                      )}
                    </div>
                  </AnimationOnScroll>
                </Col>
              </Fragment>
            ) : (
              <Fragment>
                <Col md={9}>
                  <AnimationOnScroll
                    animateOnce
                    animateIn="animate__fadeInDown"
                    offset={0}
                  >
                    <div>
                      {this.props.tag && (
                        <div className={styles.headerTag}>
                          {this.props.tagStrong && (
                            <span className={styles.headerTagStrong}>
                              {this.props.tagStrong}
                            </span>
                          )}
                          <span className={styles.headerTagNormal}>
                            {this.props.tag}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className={styles.headerDiv}>
                      <h1
                        className={styles.header}
                        dangerouslySetInnerHTML={{ __html: this.props.header }}
                      />
                    </div>
                  </AnimationOnScroll>
                  <div>
                    <AnimationOnScroll
                      animateOnce
                      animateIn="animate__fadeInUp"
                      offset={0}
                    >
                      <h2 className={styles.subHeader}>
                        {this.props.subHeader}
                      </h2>
                    </AnimationOnScroll>
                  </div>
                </Col>
                {link && linkText && (
                  <Col md={3} className={styles.actionLinkHolder}>
                    <AnimationOnScroll
                      animateOnce
                      animateIn="animate__fadeIn"
                      offset={0}
                      delay={200}
                    >
                      <Link
                        to={
                          link.indexOf("#positions") > -1 ? "/careers/" : link
                        }
                        className={styles.actionLink}
                        onClick={(e) => {
                          if (handleLinkScroll) {
                            handleLinkScroll(e);
                          } else {
                            link.indexOf("#") > -1 &&
                              scroller.scrollTo(link.replace(/^.+#/, ""), {
                                duration: 800,
                                smooth: true,
                                offset: -60,
                              });
                          }
                        }}
                      >
                        {linkText}
                        <span>
                          <img src={goArrow} alt="goArrow" />
                        </span>
                      </Link>
                    </AnimationOnScroll>
                  </Col>
                )}
              </Fragment>
            )}
          </Row>
          {demoModalVisible ? (
            <DemoModal
              handleClose={() => this.setState({ demoModalVisible: false })}
            />
          ) : null}
          {confirmationModalVisible ? (
            <ConfirmationModal
              handleClose={() =>
                this.setState({ confirmationModalVisible: false })
              }
            />
          ) : null}
        </Container>
      </div>
    );
  }
}
